<template>
  <div>
    <table>
      <thead>
        <tr>
          <th rowspan="2">{{ $t('Nivel') }}</th>
          <th colspan="4">{{ $t('Proyectos') }}</th>
          <th colspan="2">{{ $t('Operaciones') }}</th>
          <th rowspan="2">{{ $t('Seguridad y Salud Ocupacional') }}</th>
          <th rowspan="2">{{ $t('Medio Ambiente') }}</th>
          <th rowspan="2">{{ $t('Comunidades') }}</th>
          <th rowspan="2">{{ $t('Legal') }}</th>
          <th rowspan="2">{{ $t('Reputación') }}</th>
        </tr>
        <tr style="background-color: rgb(7, 116, 141);">
          <th>{{ $t('CAPEX') }}</th>
          <th>{{ $t('OPEX') }}</th>
          <th>{{ $t('Plazo') }}</th>
          <th>{{ $t('NPV') }}</th>
          <th>{{ $t('EBITDA') }}</th>
          <th>{{ $t('Producción') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="impacto in impactos" :key="impacto._id" :class="{ 'fondo-celda' : validPar(impacto._id) === false  }">
          <td class="text-center">{{impacto.nivelSeveridad}}</td>
          <td class="text-center" @click="click(impacto, 'Proyectos', impacto['capex']['descriptor'])">{{ impacto['capex']['descriptor'] }}</td>
          <td class="text-center" @click="click(impacto, 'Proyectos', impacto['opex']['descriptor'])">{{ impacto['opex']['descriptor'] }}</td>
          <td class="text-center" @click="click(impacto, 'Proyectos', impacto['plazo']['descriptor'])">{{ impacto['plazo']['descriptor'] }}</td>
          <td class="text-center" @click="click(impacto, 'Proyectos', impacto['npv']['descriptor'])">{{ impacto['npv']['descriptor'] }}</td>
          <td class="text-center" @click="click(impacto, 'Operaciones', impacto['ebitda']['descriptor'])">{{ impacto['ebitda']['descriptor'] }}</td>
          <td class="text-center" @click="click(impacto, 'Operaciones', impacto['produccion']['descriptor'])">{{ impacto['produccion']['descriptor'] }}</td>
          <td width="300px" @click="click(impacto, 'Salud y Seguridad Ocupacional', impacto['sso']['descriptor'])">{{ impacto['sso']['descriptor'] }}</td>
          <td width="300px" @click="click(impacto, 'Medioambiente', impacto['medioambiente']['descriptor'])">{{ impacto['medioambiente']['descriptor'] }}</td>
          <td width="300px" @click="click(impacto, 'Comunidades', impacto['comunidades']['descriptor'])">{{ impacto['comunidades']['descriptor'] }}</td>
          <td width="300px" @click="click(impacto, 'Legal', impacto['legal']['descriptor'])">{{ impacto['legal']['descriptor'] }}</td>
          <td width="300px" @click="click(impacto, 'Reputación', impacto['reputacion']['descriptor'])">{{ impacto['reputacion']['descriptor'] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TablaSeveridad",
  props: {
    impactType: {
      required: true,
      default: "descriptor"
    },
    click: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      impactos: [
        {
          _id: 3,
          nivelSeveridad: 5,
          capex: {
            descriptor: this.$t(`>20%`)
          },
          opex: {
            descriptor: this.$t(`>10%`)
          },
          plazo: {
            descriptor: this.$t(`>30%`)
          },
          npv: {
            descriptor: this.$t(`>50%`)
          },
          ebitda: {
            descriptor: this.$t(`>50%`)
          },
          produccion: {
            descriptor: this.$t(`>15%`)
          },
          sso: {
            descriptor: this.$t(`Accidente o enfermedad ocupacional que causa múltiples fatalidades o incapacidades permanentes >40%.`)
          },
          medioambiente: {
            descriptor: this.$t(`Daño ambiental irreversible, con efectos por largo plazo en área extendida. Puede afectar el permiso ambiental vigente.`)
          },
          comunidades: {
            descriptor: this.$t(`Incidente grave que afecte una localidad con daño severo e irreversible a la calidad de vida de las personas. Irrupción de conflictos sociales que detenga la operación, pérdida de licencia social para operar.`)
          },
          legal: {
            descriptor: this.$t(`Transgresiones o incumplimientos a normas anticorrupción (de la ley 20.393, Antibribery Act o similar) o de libre competencia: u otras transgresiones o incumplimientos normativos qye, se estima, pueden dar lugar a una revocación pérdida de los permisos para operar, sansión o resultado adverso superior al 20% del EBITDA.`)
          },
          reputacion: {
            descriptor: this.$t(`Afectación severa de la reputación internacionalmente y de credibilidad institucional de la empresa con efectos por largo plazo.`)
          }
        },
        {
          _id: 4,
          nivelSeveridad: 4,
          capex: {
            descriptor: this.$t(`15-20%`)
          },
          opex: {
            descriptor: this.$t(`5-10%`)
          },
          plazo: {
            descriptor: this.$t(`20-30%`)
          },
          npv: {
            descriptor: this.$t(`20-50%`)
          },
          ebitda: {
            descriptor: this.$t(`20-50%`)
          },
          produccion: {
            descriptor: this.$t(`6-15%`)
          },
          sso: {
            descriptor: this.$t(`Accidente o enfermedad ocupacional que causa una fatalidad o incapacidad permanente >40%.`)
          },
          medioambiente: {
            descriptor: this.$t(`Daño ambiental reversible, con efectos por mediano plazo en área extensa, que requiere acciones de demediación. Puede afectar el permiso ambiental vigente..`)
          },
          comunidades: {
            descriptor: this.$t(`Incidente mayor que afecte una localidad con daño serio a la calidad de vida de las personas. Irrupción de conflictos sociales que detenga la operación. Efectos negativos entre relación empresa comunidad, reversible LP.`)
          },
          legal: {
            descriptor: this.$t(`TRansgresiones o incumplimientos normativos que, se estima, pueden dar lugar a una condena penal, sansión o resultado adverso superior a un 3% y hasta un 20% del EBITDA.`)
          },
          reputacion: {
            descriptor: this.$t(`Afectación alta de la reputación nacional y de credibilidad institucional de la empresa con efectos por mediano plazo.`)
          }
        },
        {
          _id: 5,
          nivelSeveridad: 3,
          capex: {
            descriptor: this.$t(`8-15%`)
          },
          opex: {
            descriptor: this.$t(`3-5%`)
          },
          plazo: {
            descriptor: this.$t(`10-20%`)
          },
          npv: {
            descriptor: this.$t(`10-20%`)
          },
          ebitda: {
            descriptor: this.$t(`10-20%`)
          },
          produccion: {
            descriptor: this.$t(`3-6%`)
          },
          sso: {
            descriptor: this.$t(`Accidente con tiempo perdido o enfermedad ocupacional con incapacidad permanente <40%.`)
          },
          medioambiente: {
            descriptor: this.$t(`Impacto ambiental moderado, con efectos en el corto plazo y reversible naturalmente.`)
          },
          comunidades: {
            descriptor: this.$t(`Incidente leve que afecte una localidad con daño moderada a la calidad de vida de las personas. Irrupción de conflictos sociales. Efectos negativos entre relación empresa comunidad, reversible MP.`)
          },
          legal: {
            descriptor: this.$t(`Transgresiones o incumplimientos normativos que, se estima, pueden dar lugar a una formalización penal o a una sansión o resultado adverso entre un 0,05% del EBITDA.`)
          },
          reputacion: {
            descriptor: this.$t(`Reclamos moderados y titulares noticieros negativos repetitivos de alcance nacional por periodo de mediano plazo.`)
          }
        },
        {
          _id: 6,
          nivelSeveridad: 2,
          capex: {
            descriptor: this.$t(`3-8%`)
          },
          opex: {
            descriptor: this.$t(`1-3%`)
          },
          plazo: {
            descriptor: this.$t(`5-10%`)
          },
          npv: {
            descriptor: this.$t(`5-10%`)
          },
          ebitda: {
            descriptor: this.$t(`5-10%`)
          },
          produccion: {
            descriptor: this.$t(`1-3%`)
          },
          sso: {
            descriptor: this.$t(`Accidente o enfermedad ocupacional sin tiempo perdido, requiere tratamiento médico.`)
          },
          medioambiente: {
            descriptor: this.$t(`Impacto ambiental menor, localizado y reversible en el corto plazo.`)
          },
          comunidades: {
            descriptor: this.$t(`Incidente leve que afecte una localidad sin daño a la calidad de vida de las personas y sin irrupciones de la comunidad. Efectos negativos entre relación empresa comunidad, reversible CP.`)
          },
          legal: {
            descriptor: this.$t(`TRansgresiones o incumplimientos normativos que, se estima, pueden dar lugar a una sansión o resultado adverso inferior a un 0.05% del EBITDA.`)
          },
          reputacion: {
            descriptor: this.$t(`Reclamos moderados y titulares noticieros negativos de alcance nacional por periodo de corto plazo.`)
          }
        },
        {
          _id: 7,
          nivelSeveridad: 1,
          capex: {
            descriptor: this.$t(`<3%`)
          },
          opex: {
            descriptor: this.$t(`<1%`)
          },
          plazo: {
            descriptor: this.$t(`<5%`)
          },
          npv: {
            descriptor: this.$t(`<5%`)
          },
          ebitda: {
            descriptor: this.$t(`<5%`)
          },
          produccion: {
            descriptor: this.$t(`<1%`)
          },
          sso: {
            descriptor: this.$t(`Accidente o enfermedad ocupacional menor, sin tiempo perdido que no requiere tratamiento médico.`)
          },
          medioambiente: {
            descriptor: this.$t(`Impacto ambiental limitada y reducida con baja significancia ambiental y fácil de reparar.`)
          },
          comunidades: {
            descriptor: this.$t(`Incidente leve que no sea percibido por la comunidad y no afecte si calidad de vida.`)
          },
          legal: {
            descriptor: this.$t(`Transgresiones o incumplimientos normativos que, se estima, no darán lugar a sansiones monetarias.`)
          },
          reputacion: {
            descriptor: this.$t(`Reclamos sin fundamentos que no lleguen a los medios de comunicación formales.`)
          }
        }
      ]
    };
  },
  methods: {
    validPar(valor) {
      return (valor%2)? true : false;
    }
  }
};
</script>

<style scoped>
.fondo-celda {
  background-color: rgb(162, 211, 210);
}
table {
  border-collapse: collapse;
}
thead {
  color: white;
}
thead tr:first-child {
  background-color: rgb(7, 116, 141);
}
thead tr:nth-child(2) {
  background-color: rgb(250, 182, 54);
}
td,
th {
  padding: 10px;
  border: 1px solid #454545;
}
td:first-child,
td:nth-child(2),
td:nth-child(3) {
  padding: 15px;
}
td:nth-child(2):hover,
td:nth-child(3):hover,
td:nth-child(4):hover,
td:nth-child(5):hover,
td:nth-child(6):hover,
td:nth-child(7):hover,
td:nth-child(8):hover,
td:nth-child(9):hover,
td:nth-child(10):hover,
td:nth-child(11):hover,
td:nth-child(12):hover,
td:nth-child(13):hover,
td:nth-child(14):hover,
td:nth-child(15):hover,
td:nth-child(16):hover,
td:nth-child(17):hover {
  cursor: pointer;
  transition: 0.5s background-color;
  background-color: #ececec;
}
</style>
